


























import Vue from "vue";
import AdvertisementPreview from "@/components/Form/AdvertisementPreview.vue";
import { HeaderProcess } from "@/plugins/HeaderProcess";
export default Vue.extend({
  components: { AdvertisementPreview },
  data() {
    return {
      advertisement: {},
      advertisementExpanded: false,
      isLoading: true
    };
  },
  computed: {
    headerProcess() {
      const hp = new HeaderProcess();
      hp.processes.push({ idx: 1, title: "広告修正" });
      hp.processes.push({ idx: 2, title: "広告修正確認画面" });
      hp.processes.push({ idx: 3, title: "広告修正完了" });

      hp.activeIdx = 3;

      return hp;
    },
    isPage() {
      return true;
    }
  },
  mounted() {
    (async () => {
      this.advertisement = await this.$store.dispatch("get", [
        "/api/adv/posts/" + this.$route.params.id
      ]);
      this.$forceUpdate();
      this.isLoading = false;
    })();
  }
});
